<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            
            <v-col class="col-md-12 col-sm-12">
              <v-card>
                <v-card-title> Información del paciente </v-card-title>
                <v-card-text>
                  <v-tabs v-model="tab" centered icons-and-text>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1">
                      Personal
                      <v-icon>mdi-account-box</v-icon>
                    </v-tab>
                    <v-tab href="#tab-2">
                      Contacto
                      <v-icon>mdi-phone</v-icon>
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <v-tab-item :value="'tab-1'">
                      <v-card flat>
                        <v-card-text>
                          <v-simple-table dense>
                            <thead>
                              <tr>
                                <th>Paciente</th>
                                <th>CURP</th>
                                <th>NSS</th>
                                <th>Fecha de nacimiento</th>
                                <th>IDEE</th>
                                <th>Fecha de registro</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  {{ datosPaciente.patient.fullNamePatient }}
                                </td>
                                <td>{{ datosPaciente.patient.curp }}</td>
                                <td>{{ datosPaciente.patient.patientNSS }}</td>
                                <td>{{ datosPaciente.patient.birthday }}</td>
                                <td>{{ datosPaciente.patient.idee }}</td>
                                <td>
                                  {{ datosPaciente.patient.registrationDate }}
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item :value="'tab-2'">
                      <v-card flat>
                        <v-card-text>
                          <v-simple-table dense>
                            <thead>
                              <tr>
                                <th>Dirección</th>
                                <th>Télefono de casa</th>
                                <th>Télefono móvil</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  {{ datosPaciente.patient.directionStreet }},
                                  {{ datosPaciente.patient.directionColony }},
                                  {{ datosPaciente.patient.directionCity }},
                                  {{ datosPaciente.patient.directionState }}
                                </td>
                                <td>{{ datosPaciente.patient.homePhone }}</td>
                                <td>{{ datosPaciente.patient.mobilePhone }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col class="col-md-6 col-sm-12">
              <v-card>
                <v-card-title>Citas</v-card-title>
                <v-card-text>
                  <v-simple-table dense fixed-header height="300px">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Fecha de cita</th>
                        <th>Prediagnostico</th>
                        <th>Especialidad</th>
                        <th>Doctor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          citas, index
                        ) in datosPaciente.medicalAppointments"
                        :key="citas.id"
                        :id="index"
                      >
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td>
                          {{ citas.starDate }}
                        </td>
                        <td>
                          {{ citas.comment }}
                        </td>
                        <td>
                          {{ citas.specialty }}
                        </td>
                        <td>
                          {{ citas.doctorId }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col class="col-md-6 col-sm-12">
              <v-card>
                <v-card-title>Consultas</v-card-title>
                <v-card-text>
                  <v-simple-table dense fixed-header height="300px">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Fecha de consulta</th>
                        <th>Doctor</th>
                        <th>Adicionales</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          consultas, index
                        ) in datosPaciente.medicalConsultations"
                        :key="consultas.idMedicalConsultation"
                        :id="index"
                      >
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td>
                          {{ consultas.registrationDate }}
                        </td>
                        <td>
                          {{ consultas.fullNameDoctor }}
                        </td>
                        <td>
                          <!-- {{ consultas.withStudyLaboratory }} -->
                          <v-chip
                            color="blue"
                            outlined
                            label
                            v-if="consultas.withPrescription"
                            >Receta</v-chip
                          >

                          <v-chip
                            color="green"
                            outlined
                            label
                            v-if="consultas.withStudyLaboratory"
                            >Laboratorio</v-chip
                          >

                          <v-chip
                            color="purple"
                            outlined
                            label
                            v-if="consultas.withStudyRadiology"
                            >Radiología</v-chip
                          >
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col class="col-md-6 col-sm-12">
              <v-card>
                <v-card-title>Laboratorio</v-card-title>
                <v-card-text>
                  <v-simple-table dense fixed-header height="300px">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Estudio</th>
                        <th>Fecha de solicitud</th>
                        <th>Doctor solicitante</th>
                        <th>Fecha de interpretación</th>
                        <th>Estatus</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(lab, index) in datosPaciente.laboratoryStudies"
                        :key="lab.idStudyLaboratory"
                        :id="index"
                      >
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td>
                          {{ lab.typeStudy }}
                        </td>
                        <td>
                          {{ lab.registrationDate }}
                        </td>
                        <td>
                          {{ lab.fullNameDoctor }}
                        </td>
                        <td>
                          {{ lab.startStudy }}
                        </td>
                        <td>

                          <v-tooltip bottom v-if="lab.status == 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="success"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-check-bold
                              </v-icon>
                            </template>
                            <span>Interpretado</span>
                          </v-tooltip>
                          
                          <v-tooltip bottom v-if="lab.status == 0">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="warning"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-alert-circle-outline
                              </v-icon>
                            </template>
                            <span>Pendiente</span>
                          </v-tooltip>

                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col class="col-md-6 col-sm-12">
              <v-card>
                <v-card-title>Radiología</v-card-title>
                <v-card-text>
                  <v-simple-table dense fixed-header height="300px">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Modalidad</th>
                        <th>Fecha de solicitud</th>
                        <th>Fecha de interpretación</th>
                        <th>Intérprete</th>
                        <th>Estatus</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(radio, index) in datosPaciente.studies"
                        :key="radio.identifier"
                        :id="index"
                      >
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td>
                          {{ radio.modality}}
                        </td>
                        <td>
                          {{ radio.registrationDate }}
                        </td>
                        <td>
                          {{ radio.studyDate }}
                        </td>
                        <td>
                          {{ radio.interpreterName || 'NA'}}
                        </td>
                        <td>
                          <v-tooltip bottom v-if="radio.status == 0">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="warning"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-alert-circle-outline
                              </v-icon>
                            </template>
                            <span>Pendiente</span>
                          </v-tooltip>

                          <v-tooltip bottom v-if="radio.status == 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="blue"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-play
                              </v-icon>
                            </template>
                            <span>Estudio iniciado</span>
                          </v-tooltip>

                          <v-tooltip bottom v-if="radio.status == 2">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="orange"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-check-circle
                              </v-icon>
                            </template>
                            <span>Estudio cerrado</span>
                          </v-tooltip>
                          
                          <v-tooltip bottom v-if="radio.status == 3">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="success"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-check-bold
                              </v-icon>
                            </template>
                            <span>Interpretado</span>
                          </v-tooltip>

                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "Historial",
  data: () => ({
    tab: null,
    text: "Hola",
  }),
  props: {
    datosPaciente: Object,
  },
};
</script>